export const removeEmptyFromObject = (obj) => {
  if (!obj) {
    return {};
  }
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null));
};

export const assignNonNullValues = (target, source) => {
  return Object.assign(target, removeEmptyFromObject(source));
};
